(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("buildbot-data-js", [], factory);
	else if(typeof exports === 'object')
		exports["buildbot-data-js"] = factory();
	else
		root["buildbot-data-js"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 